import styled from 'styled-components';

export const SingleCourseContainer = styled.main`
  min-height: 100vh;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.l};
  background-color: ${({ theme }) => theme.colors.offWhite};
`;

export const BreadcrumbContainer = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const SingleCardContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.l};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.shadow3};
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: ${({ theme }) => theme.spacing.l};
`;

export const SingleTop = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.l};
  align-items: flex-start;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const SingleCourseImage = styled.div`
  flex: 1;
  img {
    width: 100%;
    height: auto;
    max-height: 400px;
    object-fit: cover;
    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: ${({ theme }) => theme.shadows.shadow2};
  }
`;

export const SingleCourseInfo = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};

  .courseTop {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      /* color: ${({ theme }) => theme.colors.primary}; */
    }

    h3 {
      /* color: ${({ theme }) => theme.colors.secondary}; */
    }
  }

  .courseDescription {
    h3 {
      color: ${({ theme }) => theme.colors.grey6};
    }

    p {
      color: ${({ theme }) => theme.colors.grey5};
      line-height: 1.6;
    }
  }

  .industries {
    margin-bottom: ${({ theme }) => theme.spacing.m};
    h4 {
      color: ${({ theme }) => theme.colors.grey6};
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      gap: ${({ theme }) => theme.spacing.xs};
      padding: 0;
      list-style: none;

      li {
        background-color: ${({ theme }) => theme.colors.grey1};
        padding: ${({ theme }) => theme.spacing.xs};
        border-radius: ${({ theme }) => theme.borderRadius};
        color: ${({ theme }) => theme.colors.grey7};
        list-style: none;
      }
    }
  }

  .expiryDate {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.grey6};
  }
`;
export const SingleButtonContainer = styled.div`
  /* border: 4px solid red; */
  display: flex;
  justify-content: end;
`;

export const SingleButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* width: 30%; */
  /* border: 1px solid pink; */
  p {
    text-align: center;
    margin-bottom: ${({ theme }) => theme.spacing.xs};
  }
  button {
    width: 250px;
    padding: ${({ theme }) => theme.spacing.m};
    /* background-color: ${({ theme }) => theme.colors.primary}; */
    color: ${({ theme }) => theme.colors.white};
    border: none;
    border-radius: ${({ theme }) => theme.borderRadius};
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.grey5};
    }
  }

  @media screen and (max-width: 768px) {
    justify-content: center;

    button {
      width: 100%;
    }
  }
`;

export const RecommendedCoursesContainer = styled.section`
  overflow-x: scroll;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
  margin-top: ${({ theme }) => theme.spacing.l};
  padding-block: ${({ theme }) => theme.spacing.l};
`;
export const EachRecommendedCourse = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s};
  padding: ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  transition: transform 0.3s ease;

  img {
    height: 150px;
    width: 150px;
    object-fit: cover;
    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: ${({ theme }) => theme.shadows.shadow2};
    margin-bottom: ${({ theme }) => theme.spacing.s};
  }
  h4 {
    text-align: center;
    margin: 0;
    color: ${({ theme }) => theme.colors.grey7};
  }
  span {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.grey4};
    text-align: center;
  }

  &:hover {
    transform: scale(1.05);
  }
`;
